import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/portfolio-allocation',
  component: () => import('../../routes/PortfolioAllocation.svelte'),
  card: {
    id: 'portfolio-allocation',
    title: 'Portfolio Allocation',
    description: 'Analyze your asset allocation, compare current vs target percentages, and get rebalance suggestions.',
    icon: 'pie_chart',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/portfolio-allocation',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Portfolio Allocation Calculator – Asset Allocation & Rebalance Calculator',
    description: 'Free portfolio allocation calculator. Analyze your asset allocation breakdown, compare current vs target percentages, calculate portfolio drift, and get rebalance suggestions. Includes Conservative, Moderate, and Aggressive preset templates.',
  },
};

export default meta;
